import { OptionalLink, OptionalLinkProps } from '../01-core/OptionalLink';

export interface MenuItemProps extends OptionalLinkProps {
  /** The link label */
  label: string;
  /** Menu items */
  items?: MenuItemProps[];
}

export interface MenuProps {
  /** Menu items */
  items?: MenuItemProps[];
}

/** Block rendering multiple internal of external menu items */
export const Menu = ({ items, ...props }: MenuProps) => {
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <nav className="menu" {...props}>
      <ul className="menu__items">
        {items.map((item, i) => {
          return (
            <li key={i} className="menu__item">
              <OptionalLink
                className={[
                  'menu__link',
                  item.target && item.target == '_blank'
                    ? 'menu__link--external'
                    : '',
                ].join(' ')}
                {...item}
              >
                <span>{item.label}</span>
              </OptionalLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
